import { checkUserExists, isUserOldEnough, getRemoteDeviceActivation, getUser, getRemoteAddSharedUser, checkRemoteLogin, getUserMonthOverview, getUserWorkoutCalendar, getUserOverview, getUserSettings, getUserAchievementsExtended, isBirthdayOldEnough, getMeExtended, membershipTieringInfo } from '@engage/api-v2';
import { engageApi } from '../lib/singletons';
import { unwrap } from '../lib/unwrap';
import { toFetcher } from './toFetcher';
export var GetIsUserOldEnoughKey = "GetIsUserOldEnough";
export var toUsersFetchers = function toUsersFetchers() {
  var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : engageApi;
  return {
    GetRemoteActivation: toFetcher(function (_ref) {
      var activationId = _ref.activationId;
      return "GetRemoteActivation[".concat(activationId, "]");
    }, function (req) {
      return unwrap(function () {
        return getRemoteDeviceActivation(api, req.userId, req.activationId);
      });
    }, {
      revalidateOnFocus: false
    }),
    GetRemoteAddSharedUser: toFetcher(function (_ref2) {
      var remoteAddSharedUserId = _ref2.remoteAddSharedUserId;
      return "GetRemoteAddSharedUser[".concat(remoteAddSharedUserId, "]");
    }, function (req) {
      return unwrap(function () {
        return getRemoteAddSharedUser(api, req.userId, req.remoteAddSharedUserId);
      });
    }, {
      revalidateOnFocus: false
    }),
    GetIsUserOldEnough: toFetcher(function () {
      return GetIsUserOldEnoughKey;
    }, function (req) {
      return unwrap(function () {
        return !!(req !== null && req !== void 0 && req.shouldSkipFetch) ? new Promise(function () {
          return null;
        }) : isUserOldEnough(api);
      });
    }),
    GetMe: toFetcher(function () {
      return "GetMe";
    }, function (req) {
      return unwrap(function () {
        return getMeExtended(api, req.pelotonPlatform);
      });
    }),
    CheckRemoteLogin: toFetcher(function (_ref3) {
      var userCode = _ref3.userCode;
      return "CheckRemoteLogin[".concat(userCode, "]");
    }, function (req) {
      return unwrap(function () {
        return checkRemoteLogin(api, req.userCode);
      });
    }, {
      revalidateOnFocus: false
    }),
    GetUser: toFetcher(function (_ref4) {
      var isOnboarded = _ref4.isOnboarded;
      return "GetUser".concat(isOnboarded);
    }, function (req) {
      return unwrap(function () {
        return getUser(api, req.id, req.pelotonPlatform, req.isOnboarded);
      });
    }),
    GetMonthOverview: toFetcher(function (_ref5) {
      var id = _ref5.id,
          month = _ref5.month;
      return "GetMonthOverview".concat(id).concat(month);
    }, function (req) {
      return unwrap(function () {
        return getUserMonthOverview(api, req.id, req.month);
      });
    }),
    GetWorkoutCalendar: toFetcher(function (_ref6) {
      var id = _ref6.id;
      return "GetCalendar".concat(id);
    }, function (req) {
      return unwrap(function () {
        return getUserWorkoutCalendar(api, req.id, req.pelotonClientDate);
      });
    }),
    GetOverview: toFetcher(function (_ref7) {
      var id = _ref7.id;
      return "GetOverview".concat(id);
    }, function (req) {
      return unwrap(function () {
        return getUserOverview(api, req.id, 1, 'recent_workouts', 2);
      });
    }),
    CheckUserExists: toFetcher(function (_ref8) {
      var username = _ref8.username,
          email = _ref8.email;
      return "CheckUserExists[".concat(username, "][").concat(email, "]");
    }, function (optParams) {
      return unwrap(function () {
        return checkUserExists(api, optParams.email, optParams.username);
      });
    }),
    CheckFreeTrialEligibility: toFetcher(function () {
      return "CheckFreeTrialEligibility";
    }, function () {
      return unwrap(function () {
        return api.axios.get('/api/user/free_trial_eligibility');
      });
    }),
    GetUserSettings: toFetcher(function () {
      return "GetUserSettings";
    }, function (req) {
      return unwrap(function () {
        return getUserSettings(api, req.id);
      });
    }),
    GetUserAchievements: toFetcher(function () {
      return "GetUserAchievements";
    }, function (req) {
      return unwrap(function () {
        return getUserAchievementsExtended(api, req.id);
      });
    }),
    GetIsBirthdayOldEnough: toFetcher(function (_ref9) {
      var birthday = _ref9.birthday,
          country = _ref9.country;
      return "GetIsBirthdayOldEnough".concat(country).concat(birthday);
    }, function (req) {
      return unwrap(function () {
        return isBirthdayOldEnough(api, req.birthday, req.country);
      });
    }),
    GetMembershipTieringInfo: toFetcher(function () {
      return "GetMembershipTieringInfo";
    }, function (req) {
      return unwrap(function () {
        return !!(req !== null && req !== void 0 && req.shouldSkipFetch) ? new Promise(function () {
          return null;
        }) : membershipTieringInfo(api);
      });
    })
  };
};